module.exports = __webpack_public_path__ + "static/media/franklin-chua.081cfa72.png";